<template>
  <l-fixed-window>
    <v-tabs grow slot="fixed-top" v-model="tabs">
      <v-tab href="#smsTemplate">短信模板</v-tab>
      <v-tab href="#wechatTemplate">微信模板</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="'smsTemplate'">
          <sms-template-list></sms-template-list>
        </v-tab-item>
        <v-tab-item :value="'wechatTemplate'" >
          <wechat-template-list></wechat-template-list>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </l-fixed-window>
</template>
<script>
import smsTemplateList from './smsTemplateList'
import WechatTemplateList from './wechatTemplateList'
export default {
  name: 'messageTemplate',
  components: {
    WechatTemplateList,
    smsTemplateList
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>
